module.exports = __webpack_public_path__ + "img/aboveNormal.402537ec.svg";